import React, { PropsWithChildren } from 'react';

import { Dialog, DialogContent, DialogTrigger } from 'components/ui/dialog';

function IframeDialog({ title, src, children }: PropsWithChildren<{ title: string; src: string }>) {
  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="h-[80vh] w-full max-w-[640px] p-0">
        <iframe src={src} title={title} width="100%" height="100%" className="rounded" allow="clipboard-write" />
      </DialogContent>
    </Dialog>
  );
}

export default IframeDialog;
